import React from "react";
import { ViewMode } from "../../../redux/actions/user/userAction";
import "../../../assets/scss/components/_view-mode-toggle.scss";

interface IViewModeToggleProps {
	currentMode: ViewMode;
	onModeChange: (mode: ViewMode) => void;
	className?: string;
}

/**
 * ViewModeToggle Component
 * Toggle between Supplier and Manufacturer views
 * Always functional regardless of subscription status
 */
const ViewModeToggle: React.FC<IViewModeToggleProps> = ({
	currentMode,
	onModeChange,
	className = ""
}) => {
	return (
		<div className={`view-mode-toggle ${className}`}>
			<button
				type="button"
				className={`view-mode-button ${currentMode === "supplier" ? "active" : ""}`}
				onClick={() => onModeChange("supplier")}
				aria-label="Switch to Supplier view"
				aria-pressed={currentMode === "supplier"}
			>
				<span className="view-mode-label">Supplier</span>
			</button>
			<button
				type="button"
				className={`view-mode-button ${currentMode === "manufacturer" ? "active" : ""}`}
				onClick={() => onModeChange("manufacturer")}
				aria-label="Switch to Manufacturer view"
				aria-pressed={currentMode === "manufacturer"}
			>
				<span className="view-mode-label">Manufacturer</span>
			</button>
		</div>
	);
};

export default ViewModeToggle;

